const { REACT_APP_API_URL: API_URL = '', REACT_APP_LLM_AGENT_API_URL: LLM_AGENT_URL } = process.env;
export const { REACT_APP_OAUTH_KEY: OAUTH_KEY = '' } = process.env;

export const API_URLS = {
  PROFILE: `${API_URL}/api/v2/profile`,
  TOKEN: `${API_URL}/oauth/token`,
  PASSWORD_RESET: `${API_URL}/password_resets`,
  PASSWORD_UPDATE: (token: string | undefined): string => `${API_URL}/password_resets/${token}`,
  COUNTRIES: `${API_URL}/api/v2/beta_countries`,
  KPIS: `${API_URL}/api/v2/kpis`,
  // Provisional until the EN-518 backend contract is agreed.
  CUSTOM_KPIS: (studyUuid: string): string => `${API_URL}/api/v3/studies/${studyUuid}/custom_kpis`,
  CUSTOM_KPI: (studyUuid: string, uuid: string): string => `${API_URL}/api/v3/studies/${studyUuid}/custom_kpis/${uuid}`,
  RESTRICTIONS: `${API_URL}/api/v3/restrictions`,
  SEGMENTS_CHARACTERISTICS: (studyid: string): string => `${API_URL}/api/v2/studies/${studyid}/characteristics`,
  CHARTS: `${API_URL}/api/v2/charts`,
  // Brand Funnel is only accepted by the v3 chart API.
  CHARTS_V3: `${API_URL}/api/v3/charts`,
  CHART: (chartId?: string): string => `${API_URL}/api/v3/charts/${chartId}`,
  CHART_PREVIEW: `${API_URL}/api/v3/charts/preview`,
  BETA_CHARTS: `${API_URL}/api/v2/charts/index_post`,
  SEGMENTS: `${API_URL}/api/v2/segments`,
  SEGMENT_UPDATE: (segmendId: number): string => `${API_URL}/api/v2/segments/${segmendId}`,
  EXPORT_CSV: `${API_URL}/api/v2/csv_exports`,
  STUDIES: `${API_URL}/api/v2/studies`,
  WAVE_SUMMARIES: `${API_URL}/api/v2/wave_summaries`,
  USERS: `${API_URL}/api/v2/users`,
  ASSIGN_ROLE_TO_USER: `${API_URL}/api/v2/users/invite`,
  UPDATE_USER_ROLE: (userId: unknown): string => `${API_URL}/api/v2/users/${userId}`,
  ACCEPT_INVITE: `${API_URL}/api/v2/users/accept_invite`,
  ROLES: `${API_URL}/api/v2/roles`,
  DASHBOARDS: `${API_URL}/api/v3/dashboards`,
  DASHBOARD: (dashboardId?: string): string => `${API_URL}/api/v3/dashboards/${dashboardId}`,
  DASHBOARD_DUPLICATE: (dashboardId?: string): string => `${API_URL}/api/v3/dashboards/${dashboardId}/duplicate`,
  BRAND_GROUPS: `${API_URL}/api/v2/brand_groups`,
  UPDATE_BRAND_GROUPS: (brandGroupId: string): string => `${API_URL}/api/v2/brand_groups/${brandGroupId}`,
  BRANDS: `${API_URL}/api/v3/brands`,
  FEATURES: `${API_URL}/api/v2/features`,
  TAGS: `${API_URL}/api/v2/tags`,
  FOLDERS: `${API_URL}/api/v2/folders`,
  CUSTOMER_DATA_EXPORT_TOKENS: `${API_URL}/api/v2/customer_data_export_tokens`,
  CUSTOMER_DATA_EXPORT_TOKEN: (tokenId: number): string => `${API_URL}/api/v2/customer_data_export_tokens/${tokenId}`,
  CUSTOMER_DATA_EXPORT_WEBHOOKS: `${API_URL}/api/v2/customer_data_export_webhook_subscriptions`,
  CUSTOMER_DATA_EXPORT_WEBHOOK: (webhookId: number): string => `${API_URL}/api/v2/customer_data_export_webhook_subscriptions/${webhookId}`,
  CUSTOMER_DATA_EXPORT_WEBHOOK_DELIVERIES: (webhookId: number): string =>
    `${API_URL}/api/v2/customer_data_export_webhook_subscriptions/${webhookId}/deliveries`,
  CUSTOMER_DATA_EXPORT_WEBHOOK_TEST: (webhookId: number): string =>
    `${API_URL}/api/v2/customer_data_export_webhook_subscriptions/${webhookId}/test`,
  CUSTOMER_DATA_EXPORT_WEBHOOK_RESUME: (webhookId: number): string =>
    `${API_URL}/api/v2/customer_data_export_webhook_subscriptions/${webhookId}/resume`,
  CUSTOMER_DATA_EXPORT_WEBHOOK_REDELIVER: (webhookId: number, deliveryId: number): string =>
    `${API_URL}/api/v2/customer_data_export_webhook_subscriptions/${webhookId}/deliveries/${deliveryId}/redeliver`,
  PROMPT_LIMITS: (promptLimitId: number): string => `${API_URL}/api/v2/prompt_limits/${promptLimitId}`,
  /** LLM AGENT URLS */
  CHAT: `${LLM_AGENT_URL}/chat?`,
  SESSIONS: `${LLM_AGENT_URL}/sessions`,
  DELETE_SESSION: (sessionId: number) => `${LLM_AGENT_URL}/sessions/${sessionId}`,
};
